import React from 'react'
import { ModalResolveDivergence } from '../ModalResolveDivergence'
import { NegationButton } from '../Components/NegationButton'
import * as S from './ModalConfirm.styles'

function ModalConfirm({
  show,
  title,
  alertText,
  noteText,
  action,
  onConfirm,
  disabled
}) {
  return (
    <ModalResolveDivergence show={show} title={title} action={action}>
      <S.MessageContent>
        <S.AlertIcon />
        {alertText}
        {noteText && <S.NoteText>{noteText}</S.NoteText>}
      </S.MessageContent>
      <S.ContainerButton>
        <NegationButton
          title={'Confirmar'}
          onClick={onConfirm}
          disabled={disabled}
        />
      </S.ContainerButton>
    </ModalResolveDivergence>
  )
}

export default ModalConfirm
